import { debug } from "console";

const awsmobile = {
    Auth: {
        Cognito: {
            authenticationFlowType: 'USER_SRP_AUTH',
            identityPoolId: process.env.REACT_APP_COGNITO_ID_POOL!,
            loginWith: {
                email: true,
                username: true
            },
            userPoolClientId: process.env.REACT_APP_COGNITO_CLIENT!,
            userPoolId: process.env.REACT_APP_COGNITO_USER_POOL!
        },
    },
    API: {
        REST: {
            API: {
                endpoint: process.env.REACT_APP_API_GATEWAY_URL!,
                region: process.env.REACT_APP_AWS_REGION!
            }
        }
    },
    Storage: {
        S3: {
            accessKeyId: process.env.REACT_APP_BUCKET_ACCESS_KEY!,
            accessSecretKey: process.env.REACT_APP_BUCKET_SECRET!,
            bucket: process.env.REACT_APP_STORAGE_BUCKET!,
            region: process.env.REACT_APP_AWS_REGION!
        }
    }
};

export default awsmobile;